export default "__VITE_ASSET__bdafd723__"